import {FrontendPage} from "../FrontendPage";
import {TableScroller} from "../TableScroller";
import {$} from "../Frontend";

export class Trip extends FrontendPage {
    onReady() {
        window.scroller = new TableScroller(() => $('#trips_wrapper .dataTables_scroll').parent());
    }

    runOnCurrentPage(): boolean {
        return $('#trips').length > 0;
    }
}
